const { default: axiosInstance, endpoints } = require('src/utils/axios-visa');

/* eslint-disable class-methods-use-this */

class NewsletterService {
  subscribe = async (email) => {
    try {
      const response = await axiosInstance.post(endpoints.newsletter.subscribe, { email });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  };
}

const newsletterService = new NewsletterService();
export default newsletterService;
